/**
 * Fixed UI copy of the registration (Figma „Registrácia“ 60260:27827, 60260:28858, „Učet vytvorený“
 * 60260:30410). Labels that exist word for word in the core dictionary (Meno, E-mail, IČO …) are
 * read with `t()` in the components; everything else is not administration content and has no
 * dictionary key, so it lives here.
 */
export const REGISTER_SUCCESS_PARAM = 'ucet-vytvoreny';

export const REGISTER_COPY = {
  pageTitle: 'Vytvoriť konto',
  intro: 'Registrácia trvá menej ako minútu. Nakupovať môžete ako fyzická osoba aj ako firma.',
  persona: {
    title: 'Registrujem sa ako',
    label: 'Typ konta',
    individual: 'Fyzická osoba',
    company: 'Firma / podnikateľ',
  },
  credentials: {
    emailHint: 'Na tento e-mail pošleme potvrdenie registrácie.',
    emailPlaceholder: 'vas@email.sk',
    repeatPassword: 'Zopakujte heslo',
    passwordPlaceholder: '••••••••••',
    passwordRules: 'Heslo musí mať aspoň 8 znakov, veľké písmeno a číslo.',
  },
  personal: {
    phoneHint: 'Kuriér vás bude kontaktovať pred doručením.',
    phonePlaceholder: '+421...',
    phoneInvalid: 'Zadajte telefónne číslo vrátane predvoľby, napr. +421 900 123 456.',
  },
  address: {
    street: 'Ulica a číslo domu',
    postcode: 'PSČ - Poštové smerovacie číslo',
    postcodePlaceholder: '000 00',
  },
  billing: {
    hint: 'Nepovinné údaje - môžete vyplniť pri objednávke alebo v profile.',
    otherDelivery: 'Doručovacia adresa je iná ako fakturačná',
  },
  company: {
    title: 'Údaje o firme',
    lookup: 'Vyhľadať',
    lookupHint: 'Údaje o firme doplníme z obchodného registra',
    lookupDone: 'Údaje o firme sme doplnili.',
    lookupNotFound: 'Firmu sa nepodarilo nájsť. Údaje vyplňte ručne.',
    lookupFailed: 'Vyhľadávanie sa nepodarilo. Skúste to znova alebo údaje vyplňte ručne.',
    vatHint: 'Vyplňte, ak ste platiteľ DPH',
    otherDelivery: 'Tovar doručiť na inú adresu ako sídlo firmy.',
  },
  delivery: {
    title: 'Doručovacia adresa',
    recipient: 'Názov prevádzky / príjemca',
    contact: 'Kontaktná osoba na mieste',
    contactPlaceholder: 'Meno Priezvisko',
  },
  contact: {
    title: 'Kontaktná osoba',
    emailHint: 'Sem pošleme potvrdenie a faktúru.',
  },
  consents: {
    termsPrefix: 'Súhlasím s ',
    terms: 'obchodnými podmienkami',
    termsJoin: ' a ',
    privacy: 'spracovaním osobných údajov',
    businessAccount: 'Vytvoriť firemný účet – nákup na faktúru a firemné ceny po schválení',
    newsletterIndividual: 'Chcem dostávať novinky, akcie a zľavové kupóny e-mailom',
    newsletterCompany: 'Chcem dostávať novinky a zľavy e-mailom',
  },
  submit: 'Vytvoriť účet',
  failed: 'Registráciu sa nepodarilo dokončiť',
  detailsFailed:
    'Konto bolo vytvorené, ale adresu a firemné údaje sa nepodarilo uložiť. Doplníte ich v profile.',
  businessAccountFailed: 'Žiadosť o firemný účet sa nepodarilo odoslať.',
  businessAccountRequest: {
    subject: 'Žiadosť o firemný účet',
    text: 'Zákazník sa zaregistroval ako firma a žiada o firemný účet (nákup na faktúru a firemné ceny).',
  },
  success: {
    title: 'Účet bol úspešne vytvorený',
    text: 'Na zadanú e-mailovú adresu pri registrácii sme zaslali aktivačný link pre aktiváciu vášho účtu.',
    resend: 'Odoslať aktivačný link znovu',
    sent: 'Aktivačný link sme odoslali znovu.',
    failed: 'Aktivačný link sa nepodarilo odoslať. Skúste to znova.',
    cooldown: 'Ďalší môžete odoslať o',
  },
} as const;
